<template>
  <!--
  HOW TO USE
  {
    subject: 'User NPS to get feedback from your website',
    tag: ['optimization idea'],
    body: 'This is just a testing message to see how it would work in action',
    image: 'https://i.stack.imgur.com/uZqgF.jpg',
    link: 'https://howuku.com',
    label: 'Continue',
  },
-->
  <div>
      <modal
      name="show-install-1"
      :adaptive="true"
      width="850px"
      height="90%"
      style="z-index: 99999;"
      >
        <InstallRecommendation :recommendPlugin="recommendPlugin" :selectedWidgetId="widgetId" :isNotAddWebsite="true"/>
      </modal>                                    
    <div
      style="z-index: 99 !important"
      id="bot-container"
      v-if="showMessage && !$isOptimize"
    >
      <div class="speech-container">
        <!-- <transition>
          <div class="btn-close " @click="showMessage = false" >
            <img width="25" height="25" src="https://cdn.howuku.com/images/close-icon.png" class="cursor-pointer mr-4" >
            <span class="cursor-pointer font-weight-bold" style="width:20px">X</span>
            <div class="close"></div>
          </div>
        </transition> -->
        <div>
        <div class="d-flex " style="background:rgb(5, 74, 218);height: 60px;  align-items: center;justify-content: center;" >
            <h4
            class="text-center text-white"
            style="margin-bottom: 0px;"
            >
            Quickstart
          </h4>
        </div>
        <!-- <svg
          width="100%"
          height="140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 360 140"
          preserveAspectRatio="none"
        >
          <rect id="Rectangle" width="100%" height="140" fill="#101d3b"></rect>
          <path
            d="M152.5 48.5C65.5 -9.5 -5.50005 61 0.999949 140H365V35.5C365 35.5 239.5 106.5 152.5 48.5Z"
            fill="url(#linearGradient)"
            fill-opacity="0.9"
          ></path>
          <defs>
            <linearGradient
              id="linearGradient"
              x1="360"
              y1="108.121"
              x2="97.062"
              y2="164.602"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0%"
                stop-color="var(--ds-background-accent-purple-subtle, #16367d)"
              ></stop>
              <stop
                offset="100%"
                stop-color="var(--ds-background-accent-purple-subtle, #16367d)"
                stop-opacity="0"
              ></stop>
            </linearGradient>
          </defs>
        </svg> -->
        <!-- :style="'width: ' + progress + '%'" -->
        <div class="speech">
          <template v-for="(item, key) in steps" v-bind:steps="steps">
            <div class="speech-item" v-if="item" v-bind:key="key" v-bind:item="item">
              <div v-if="key === 0 " class="speech-progression-bar" :style="'width:' + progress + '%'" style="margin-bottom:-8px;height:8px;z-index: 10;position: relative;"></div>
              <div
                v-if="key === 0"  
                
                style="display:flex;flex-direction:row;height: 8px;margin-bottom: 8px;"
              >
                <!-- <div><div class="speech-progression-bar" :style="'width: ' + progress + '%'" style="position:absolute"></div></div> -->
                <div v-for="(item, key) in steps"  :style="[(key=== steps.length-1) ? {'border-right' : 'none','width': 100/steps.length + '%'} : {'border-right': ' 1.5px solid #aba9a6','width': 100/steps.length + '%'}]" style="background-color:grey">
                </div>
              </div>
              <p
                class="speech-title fw-700 my-0 py-2 cursor-pointer;"
                style="display:flex;justify-content: space-between; align-items: center;cursor: pointer;"
                :style="[(notraffic) ? {'pointer-events':'none'}:{'cursor':'pointer'}]"
                @click="showTab !== key ? (showTab = key) : (showTab = null)"
              >
                <span 
                  style="display:flex; align-items: center;gap: 10px; width: 70% ;"
                >
                <img
                  class="d-inline"
                  style="width: 20px; height: 20px"
                  v-if="(item.status)"
                  src="../assets/img/green-check.svg"
                />
                <img
                  class="d-inline"
                  style="width: 20px; height: 20px"
                  v-else
                  src="../assets/img/grey-check.svg"
                /> 

                {{ item.title }}
                </span>
                <font-awesome-icon
                  v-if="showTab === key"
                  icon="chevron-down"
                  class="float-right mr-2"
                />
                <font-awesome-iconuserTypeUrl
                  v-else
                  icon="chevron-up"
                  class="float-right mr-2"
                />
              </p>
              <transition name="slideAccordeon">
                <div class="speech-body" v-show="showTab === key">
                  <div 
                  style="display:flex;justify-content: center;">
                  <img
                    v-if="item.image"
                    :src="item.image"
                    class=""
                    width="160px" height="170px"
                    style="margin:0px 15px 15px 15px;"
                    :style ="[(key=== 2) ? {'width' : '170px','height':'150px'} : {}]"
                  />  
                  </div>
                  <p  
                    class="mx-2 font-weight-450" 
                    style="text-align:justify;text-justify: inter-word;max-width: 320px;"
                    v-if="item.title !== 'Setup tracking code'" 
                  >
                    <vue-markdown>{{ item.body }}</vue-markdown>
                  </p>
                  <div v-if="item.title === 'Setup tracking code'" class="px-2">
                    <p  
                    class="my-1 font-weight-450" 
                    style="text-align:justify;text-justify: inter-word;width: 100%;margin-left: 0px !important;"
                    >
                      Obtain the tracking code and install it on your site. Once the installation is complete, a green tick will appear to indicate successful installation.
                    </p>
                    <!-- <b>Site URL</b><br /> -->
                    <!-- <input
                      class="form-control"
                      placeholder="Your website url"
                      v-model="userTypeUrl"
                      id="inputUrl"
                      style="border-width: 2px;"
                      :style = "[(notraffic)? {'border-color':'red'}:{'border-color':'green'}]"
                    />
                    <div style="color:red" class="my-1" v-if="notraffic">The url link is invalid or tracking code is not installed</div> -->
                    <div class="loadingData my-2" v-show="notraffic">
                      <div class="text-left">
                        <font-awesome-icon
                          id="chart-loading"
                          icon="circle-notch"
                          class="fa-spin text-muted fa-md"
                          style="margin-left:10px;margin-top: 10px;"
                        />
                        <span class="mx-1">Pending Data Collection....</span>
                      </div>
                    </div>
                    <button class="btn btn-cta text-white btn-block" @click="openTracking()" style=" background-color: rgb(5, 74, 218) !important;margin-top: 15px;width: 180px;">
                      Install Tracking Code
                    </button>
                  </div>
                  <div class="d-flex" style="justify-content':'space-between" >
                    <span v-if="item.link">
                      <button 
                      @click="checkAnswer(item, text),$router.push({path: item.link})"
                      class="btn btn-cta text-white btn-block" style=" background-color: rgb(5, 74, 218) !important;width: 180px"
                      >
                        {{ item.label }}
                      </button>
                    </span>
                    <!-- <a v-else-if="item.link && key === (steps.length-1)" :href="item.link" target="_blank">
                      <button 
                      @click="submitAnswer(item, text),$router.push({path: item.link})"
                      class="btn btn-cta text-white btn-block" style=" background-color: rgb(5, 74, 218) !important;width: 180px"
                      >
                        {{ item.label }}
                      </button>
                    </a> -->
                    <a v-if="(item.link2 && key !== 0)" :href="item.link2" target="_blank">
                      <button 
                      @click="checkAnswer(item, text),$router.push({path: item.link2})"
                      class="btn btn-block" style="width: 120px">
                        {{ item.label2 }}
                      </button>
                    </a>
                  </div>
                    <div v-if="item.options">
                      <button
                        @click="checkAnswer(item, text)"
                        v-for="(text, key2) in item.options"
                        v-bind:key="key2"
                        class="btn btn-cta text-white btn-block"
                      >
                        {{ text }}
                      </button>
                    </div>
                  </div>
                </transition>
              </div>
              <button
              class="btn btn-block"
              style="width:100%;position:absolute;bottom:0px;right:0px;color:rgb(5, 74, 218)" 
              @click="showMessage = false"
              >Dismiss Quickstart</button>
            </template>
          </div>
        </div>
      </div>
    </div>
    
      <div  v-else-if="!$isOptimize && showQuickStart && !showMessage" class="showClose" style="width:220px;height:100px;position: fixed;bottom: 0px;right: 0px;z-index: 99;">
        <div
          class="btn btn-cta text-white my-auto shake text-white"
          style="
            position: fixed;
            bottom: 20px;
            right: 46px;
            z-index: 99;
            border-radius: 25px;
            padding: 14px 20px;
            background-color: rgb(5, 74, 218) !important;
          "
          @click="showMessage = true"
        > 
          <font-awesome-icon class="mr-1 fa-md" icon="lightbulb" />
          Quickstart
        </div>
        <div 
        @click="closeForever()"
          class="close"
            style="position: absolute;
            bottom: 66px;
            right: 42px;
            z-index: 100;"
            >
            <!-- <div class="close"></div>  -->
        </div>

    </div>
    <!-- <div id="profile-picture" @click="showMessage = !showMessage"></div> -->
  </div>
</template>

<script>
const VueMarkdown = () => import('vue-markdown')
const InstallRecommendation = () => import('@/components/InstallRecommendation.vue')
import { store } from '@/store'
export default {
  store,
  props: ['steps'],
  components: {
    VueMarkdown,
    InstallRecommendation
  },
  data: function () {
    return {
      checkStatus:[],
      checkTitle:[],
      showTab: 0,
      showMessage: false,
      steps: [],
      progress: 0,
      notraffic:false,
      userTypeUrl:'',
      showQuickStart:false,
      recommendPlugin:'',
      widgetId:'',
      websiteURL:'',
      currentHost: window.location.host,
      record_full_location:'',
      recordSessionId:'',
      gotEvent:false,
      selected_steps: null,
      funnel_id: 0,
      funnel_name : '',
      abtest:'',
      funnels:'',
    }
  },
  beforeMount() {
    this.widgetId = this.$session.get('widget_id')
    // this.checkCurrentTraffic()
    this.checkStepsStatus()
  },
  mounted() {
  },
  watch: {
    '$store.getters.widget_id': {
      handler: function (value) {
        this.showTab = 0  
        // this.checkCurrentTraffic()
        this.checkStepsStatus()
      },
      deep: true
    },
    watch: {
      $route(to, from) {
        this.checkStepsStatus()
      }
    }
  },
  methods: {
    checkAnswer(q, answer){
      //here is to check the title and depending on the title to see what action are needed to be done
      if(q.title === "Watch recording"){
        this.openFirstRecording(q , answer)
      }else if(q.title === "View website event"){
        this.checkForEventCount(q , answer)
      }
      else if(q.title === "Setup A/B test"){
        this.addTest(q,answer)
      }
      else if(q.title === "Create Funnel"){
        this.addFunnel(q, answer)
      }else{
        this.submitAnswer(q,answer)
      }

    },
    submitAnswer(q, answer) {
        this.$http
          .post(process.env.API_ENDPOINT + '/user/attribute', {
            key: q.title,
            value: answer,
          })
          .then(() => {
            this.checkStepsStatus()
          })
          .catch((err) => {
            console.error(err)
          })
    },
    checkStepsStatus(){
      this.testing = false
      this.$http.get(process.env.API_ENDPOINT + '/user/attribute/insight')
      .then(result=>{
        if(result.data[0].insight !== null){
          this.checkForCloseForever()
          if(!(Object.keys(JSON.parse(result.data[0].insight)).length >= 1)) 
          { 
            this.showMessage = true 
          } 
          //retrive the insight from the user then turn it into json format to get the title for further checking 
          for (let index = 0; index < Object.keys(JSON.parse(result.data[0].insight)).length ; index++) {
            this.checkTitle.push(Object.keys(JSON.parse(result.data[0].insight))[index])
            this.checkStatus.push(Object.values(JSON.parse(result.data[0].insight))[index])
          }

          // filtering and asigning the status into the relevent title
          for (let i = 0; i < this.steps.length; i++) { 
            for (let j = 0; j < Object.keys(JSON.parse(result.data[0].insight)).length; j++) {
              if(this.steps[i].title === this.checkTitle[j]){
                this.steps[i].status = this.checkStatus[j]
              }
            }
          }
          if(this.notraffic){
            for (let i = 0; i < this.steps.length; i++) { this.steps[i].status = 0}

          }
          // updating the status bar
            let completed = 0
            this.steps.map((a) => {
              a.status === 1 ? completed++ : null
            })
            this.progress = (completed / this.steps.length) * 100

        }else{
          this.showMessage = true 
        }

      }
        )
      .catch((err) => {
        console.error(err)
      })
        // this is to clear out the array 
        this.checkTitle = []
        this.checkStatus = []
    },
    closeForever(){
      let closeStatus = {
        title:"closeStatus"
      }
      this.showQuickStart = false;
      this.submitAnswer(closeStatus, 1) 
    },
    checkForCloseForever(){
      this.$http.get(process.env.API_ENDPOINT + '/user/attribute/insight')
      .then(result=>{
        this.showQuickStart = true
        //retrive the insight from the user then turn it into json format to get the title for further checking 
        for (let index = 0; index < Object.keys(JSON.parse(result.data[0].insight)).length ; index++) {
          this.checkTitle.push(Object.keys(JSON.parse(result.data[0].insight))[index])
          this.checkStatus.push(Object.values(JSON.parse(result.data[0].insight))[index])
        }
        // filtering and asigning the status into the relevent title
          for (let i = 0; i < this.checkTitle.length; i++) { 
              if(this.checkTitle[i] === "closeStatus" && this.checkStatus[i] === 1) {
                this.showQuickStart = false
              }
          }
        })
        .catch((err) => {
          console.error(err)
        })
        
    }, openTracking() {
      if (this.$isMida || this.$isHowuku || this.$isOptimize || window.location.host.includes('localhost')) {
        let data = {
          websiteURL: this.websiteURL
        }
        // website CMS check
        this.$http.post(process.env.API_ENDPOINT + '/checkWebsite', data)
          .then((response) => {
            this.recommendPlugin = response.data
            this.$modal.show('show-install-1')
          })
          .catch((err) => {
            this.errorMsg = 'Error checking website CMS'
            console.log(err)
          })
      }
    },
    checkCurrentTraffic() {
      return new Promise((resolve, reject) => {
        this.$http
          .post(process.env.API_ENDPOINT + '/getWidgets', {
            widget_id: this.$session.get('widget_id')
          })
          .then(async (response) => {
            this.websiteURL = response.data[0].widget_allowed_website
            let traffic = response.data[0].pageview_total || 0
            if (traffic === 0) this.notraffic = true
            else if (response.data[0].pageview_monthly !== 0) {
              this.notraffic = false
            } else if (
              response.data[0].pageview_monthly === 0 &&
              (await this.check30dayTraffic()) === 0
            ) {
              this.notraffic = true
            } else {
              this.notraffic = true
            }
            console.log('NO TRAFFIC', this.notraffic)

            this.key++
            resolve(traffic)
          }).then(()=>{
            console.log(this.notraffic)
            let data = {title:"Setup tracking code"}
            if(this.notraffic === true){
              this.submitAnswer(data,0)
            }else{
              this.submitAnswer(data,1)
            }

          })
      })
    },
    check30dayTraffic() {
      this.$http
        .get(process.env.API_ENDPOINT + '/check/traffic')
        .then((response) => {
          return response.data.length
        })
        .catch((err) => {
          console.error(err)
          return 0
        })
    },    
    openUrl(baseurl, session, event) {
      try {
        this.$auditlog({
          module: 'activation',
          action: 'recording',
          description: 'Watch recording'
        })
        // Event snippet for Activated Users conversion page
        gtag('event', 'conversion', {'send_to': 'AW-765886616/2VISCPPZjIEYEJiBmu0C'});
      } catch (e) {}
      let url = baseurl.startsWith('https://')
        ? baseurl + '/video/' + session
        : baseurl + '/share/playback/' + session

      window.open(url, '_blank')
    },
    getProtocol(locations) {
      let l = locations.split(',')
      let protocol = 'https://'

      // do not force http

      if (l) {
        for (let i in l) {
          try {
            if (!l[i].startsWith('https://')) {
              protocol = 'http://'
              break
            }
          } catch (err) {}
        }
      }

      if (window.location.protocol === 'http:') {
        protocol = 'http://'
      }
      return protocol
    },
    openFirstRecording(q,answer){
      this.$http.get(process.env.API_ENDPOINT + '/first/recording').then((result)=>{
        console.log(result.data.length)
        if(result.data.length === 1){
          this.recordSessionId = result.data[0].session
          this.record_full_location = result.data[0].location
          this.submitAnswer(q,answer)

          setTimeout(() => {
            this.openUrl(
            this.getProtocol(this.record_full_location) + this.currentHost,
            this.recordSessionId
          )
          }, 300); 
        }
      })
    },
    checkForEventCount(q,answer){
      this.$http.post(process.env.API_ENDPOINT + '/events', {
            widget_id: this.$session.get('widget_id'),
      })
      .then((response) => {
        (response.data.length >= 1)? this.gotEvent = true:this.gotEvent = false
        console.log(response.data.length,this.gotEvent)
        if(response.data.length >= 1){
          this.submitAnswer(q,answer)
        }
      })
    },
    addTest(q,answer) {
      let option = {
        widget_id: this.$session.get('widget_id'),
      }
      this.$http.post(process.env.API_ENDPOINT + '/abtest/profile',option)
        .then((response) => {
          this.abtest = response.data
          if(response.data.length >= 1){
            this.submitAnswer(q,answer)
          }
      })

      if (
        (this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
          this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))) &&
        this.abtest.length >= 3
      ) {
        this.$swal.fire({
          title: 'Upgrade your plan',
          text:
            'You hit the maximum ' +
            (this.$route.name.includes('Personalize')
              ? 'profiles'
              : 'abtest.') +
            ' Upgrade your plan to create unlimited ' +
            (this.$route.name.includes('Personalize') ? 'profiles.' : 'tests.'),
          type: 'warning',
          confirmButtonColor: '#2167f5',
        })
        return
      } else {
        setTimeout(() => {
          this.$router.push({path:'/ab-test/new'})
        }, 300)
          // this.$http.post(process.env.API_ENDPOINT + '/abtest/profile',widget_id: this.$session.get('widget_id'))
          // .then((response) => {
          //   console.log(response.data)
          // })
      }
    },
    addFunnel(q,answer){
      let option = {
        widget_id: this.$session.get('widget_id'),
      }
      this.$http
        .post(process.env.API_ENDPOINT + '/funnel/profile', option)
        .then((response) => {
          if(response.data.length >= 1){
            this.submitAnswer(q,answer)
            console.log(response.data.length)
          }
      })

      if (
        (this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
          this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))) &&
        this.funnels.length >= 3
      ) {
        this.$swal.fire({
          title: 'Upgrade your plan',
          text: 'You hit the maximum funnels. Upgrade your plan to create unlimuted funnels.',
          type: 'warning',
          confirmButtonColor: '#3657ff',
        })
        return
      } else {
        this.funnel_id = 0
        this.funnel_name = ''
        this.selected_steps = null
        setTimeout(() => {
          this.$modal.show('add-funnel-profile')
        }, 300); 
      }
    
    }
  },
}
</script>

<style scoped>
#bot-container {
  position: fixed;
  bottom: 0px;
  right: 4px;
  width: 400px;
  /* height: calc(100% - 60px); */
  min-height: 500px;
  max-height: 823px;

}

#profile-picture {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-image: url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfwXmi4mI9pCF-hNdTgNLSCBOihecmhgfVPA&usqp=CAU');
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  border: 1px solid #cfcfcf;
  box-shadow: 0px 0.5px 1px #cfcfcf;
  cursor: pointer;
}

.speech {
  /* background-color: #101d3b; */
  background-color: white;
  /* color: white; */
  /* border-radius: 8px; */
  border: 1px solid #ececef;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.03), 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  z-index: 9999999 !important;
  margin: 20px;
  width: calc(100% - 40px);
  margin-bottom:40px !important;
}

.speech:not(:nth-child(1)) {
  margin-top: 20px;
}

.speech-container {
  /* margin-bottom: 80px; */
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  vertical-align: bottom;
  overflow-y:scroll;
  background-color: #f4f5f7;
  /* padding: 100px 20px; */
  border: solid 1px #d8d8d8;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.03), 0 1px 2px 0 rgba(0, 0, 0, 0.04);
  /* height: 100%; */
  /* max-height: 800px; */
  min-height: 500px;
  max-height: 823px;

  animation-name: animatedHeight;
  animation-duration: 0.125s; 
  animation-timing-function: ease-in-out;
  transform-origin:bottom right;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@keyframes animatedHeight {
  0%   {transform: scale(0.2);}
  50%  {transform: scale(0.6);}
  100% {transform: scale(1);}
}
.shake{
  animation: shake 1.75s 3;
    animation-timing-function: ease-in;
  transform-origin:center;
}
@keyframes shake {
  /* 0%   {transform: rotate(0deg)}
  25%   {transform: rotate(-5deg)}
  50%   {transform: rotate(5deg)}
  50%   {transform: rotate(-5deg)}
  100%  {transform: rotate(0deg)} */


  0% { transform: translate(0px, 0px) rotate(0deg); }
  10% { transform: translate(0px, -2px) rotate(0deg); }
  20% { transform: translate(0px, -4px) rotate(0deg); }
  30% { transform: translate(0px, -6px) rotate(-3deg); }
  40% { transform: translate(0px, -6px) rotate(3deg); }
  50% { transform: translate(0px, -6px) rotate(-3deg); }
  60% { transform: translate(0px, -6px) rotate(3deg); }
  70% { transform: translate(0px, -6px) rotate(0deg); }
  80% { transform: translate(0px, -4px) rotate(0deg); }
  90% { transform: translate(0px, -2px) rotate(0deg); }
  100% { transform: translate(0px, 0px) rotate(0deg); }
}
.speech-container::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
}

.btn-close {
  position: absolute;
  right: 10px;
  top: 6px;
  /* background: #ffffffdb; */
  color: #000;
  width: 20px;
  /* border-radius: 50px; */
  text-align: center;
  margin-bottom: 10px;
  margin-left: auto;
  cursor: pointer;
  /* padding: 10px; */
  opacity: 1;
}

#bot-container:hover .btn-close {
  opacity: 1;
}

.speech-item:not(:first-child) {
  /* border-bottom: 1px solid #cecece; */
  padding-top: 10px;
  padding-bottom: 10px;
}

.speech-item:first-child {
  /* border-bottom: 1px solid #cecece; */
  padding-top: 0px;
  padding-bottom: 10px;
}

.speech-item:not(:first-child) {
  border-top: 1px solid #ececef;
  /* border-top: 1px solid #253761; */
}

.speech-item p,
.speech-item button{
  margin: 0px 10px;
  width: calc(100% - 20px);
}

.speech-body {
  padding: 10px;
}

.slideAccordeon-enter-active,
.slideAccordeon-leave-active {
  transition: height 0.125s ease-out;
  /* IE 10+ */
  overflow: hidden;
}
.slideAccordeon-enter, .slideAccordeon-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0;
}
.slideAccordeon-enter-to,
.slideAccordeon-leave {
  height: 300px;
}

.speech-progression-bar {
  background-color: #36b37e;
  border: #36b37e 1px solid;
  height: 5px;
  margin-bottom: 14px;
}
.close {
  width: 16px;
  height: 16px;
  opacity: 0.5;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 16px;
  width: 2px;
  background-color: black;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.showClose > .close {
        display: none;
}
.showClose:hover > .close {
        display: block;

}
</style>



// WEBPACK FOOTER //
// src/components/AccordionSteps.vue